import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Capacitor sert l'app depuis un fichier local : HashRouter évite tout
// problème de deep link et de rechargement dans la WebView.
import { HashRouter } from 'react-router-dom'
import { App } from './App.js'
import './index.css'

const root = document.getElementById('root')
if (!root) throw new Error('#root introuvable')

createRoot(root).render(
  <StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </StrictMode>,
)
